var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowSelect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "className",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "up",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92813 0.441732C3.2173 0.145169 3.69214 0.13918 3.9887 0.428357L6.77316 3.14346C7.06973 3.43264 7.07572 3.90747 6.78654 4.20404C6.49736 4.5006 6.02253 4.50659 5.72596 4.21741L3.47848 2.02591L1.28698 4.27339C0.997799 4.56996 0.522963 4.57594 0.2264 4.28677C-0.0701634 3.99759 -0.0761516 3.52276 0.213025 3.22619L2.92813 0.441732Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92813 11.5583C3.2173 11.8548 3.69214 11.8608 3.9887 11.5716L6.77316 8.85654C7.06973 8.56736 7.07572 8.09253 6.78654 7.79596C6.49736 7.4994 6.02253 7.49341 5.72596 7.78259L3.47848 9.97409L1.28698 7.72661C0.997799 7.43004 0.522963 7.42406 0.2264 7.71323C-0.0701634 8.00241 -0.0761516 8.47724 0.213025 8.77381L2.92813 11.5583Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowSelect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-select.8e3f685796a5c1474bebd7164ee87a90.svg";